module.exports = __webpack_public_path__ + "img/bckgrdSideBar.682f8ce6.jpg";